<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-07-12 13:59:55
 * @LastEditTime: 2022-09-14 10:21:06
 * @LastEditors: chenguobiao
-->
<template>
  <div class="home-index-page flex flex-col">
    <common-header selected="user" />
    <div class="home-index-page__content flex flex-col">
      <banner :noticeList="noticeList"></banner>
      <grading-history :list="historyList" @clickGrading="handleClickGrading"></grading-history>
      <icon-contact @handleClick="clickContact"/>
      <icon-question @handleClick="clickQuestion"/>
      <grading-button @handleClick="clickButton" @handleClickRegistration="clickRegistration" :testQualifications="testQualifications" :applyQualifications="applyQualifications" :certificateQualifications="certificateQualifications" :showButton="showButton"></grading-button>
      <grading-dialog class="grading-dialog" :visible.sync="dialogConfig.visible" :title="dialogConfig.title" @close="handleClose">
        <div class="dialog-content start-grading" v-if="testQualifications">
          <div class="content-area">
            <div class="row">
              <p>试卷总分：100分</p>
              <p>及格分：{{gradingInfo.passScore}}分</p>
            </div>
            <div class="row">
              <p>考试题目：{{gradingInfo.totalCount}}道</p>
              <p>考试时间：{{formatTimes(gradingInfo.totalTime)}}</p>
            </div>
            <div class="row">
              <p>国际象棋战术题：{{gradingInfo.nationalCount}}道</p>
              <p>国际象棋战术题总分：{{gradingInfo.nationalScore}}分</p>
            </div>
            <div class="row">
              <p>国际象棋规则题：{{gradingInfo.choiceCount}}道</p>
              <p>国际象棋规则题总分：{{gradingInfo.choiceScore}}分</p>
            </div>
            <div class="row">
              <p>国际象棋实战对决：{{gradingInfo.aiCount}}道</p>
              <p>国际象棋实战对决总分：{{gradingInfo.aiScore}}分</p>
            </div>
            <div class="move-mode">
              <p class="move-mode-tips">请选择走棋方式：</p>
              <div class="row">
                <p>
                  <el-radio class="move-mode-chose" v-model="moveMode" label="drag">
                    <img :src="require(`@/render/assets/images/home/${moveMode === 'drag' ? 'icon_drag_selected' : 'icon_drag'}.png`)" alt="">
                    <span>拖拽</span>
                  </el-radio>
                </p>
                <p>
                  <el-radio class="move-mode-chose" v-model="moveMode" label="click">
                    <img :src="require(`@/render/assets/images/home/${moveMode === 'click' ? 'icon_click_selected' : 'icon_click'}.png`)" alt="">
                    <span>点跳</span>
                  </el-radio>
                </p>
              </div>
            </div>
          </div>
          <div class="dialog-button" @click="handleStart">{{orderInfo && orderInfo.productState === 7 ? '继续考试' : '开始考级'}}</div>
          <div class="tips">温馨提示：一旦开始进入正式考级，不可<span>退出</span>，否则判为<span>考试失败</span></div>
        </div>
        <!-- <div class="dialog-content" v-else>
          <div class="content-area">
            <template v-if="errorMsg">
              <p>{{errorMsg}}</p>
            </template>
            <template v-else>
              <p>尚未到考试时间！</p>
              <p>{{nextTestTime}}</p>
            </template>
          </div>
          <div class="dialog-button" @click="handleClose">关闭</div>
        </div> -->
      </grading-dialog>
      <grading-notice-dialog :visible.sync="noticDialogConfig.visible" :product="noticDialogConfig.product" @close="handleClose"  @useActivateCode="handleUseActivateCode" @success="handleApplySuccess"/>
      <use-activate-card-dialog :visible.sync="useActivateCardDialogConfig.visible" :product="useActivateCardDialogConfig.product" @close="handleUseActivateCardDialogClose" @success="handleUseActivateCodeSuccess" />
      <contact-service-dialog :visible.sync="contactServiceDialogConfig.visible" @close="contactServiceDialogConfig.visible = false" :desc="contactServiceDialogConfig.desc"/>
      <introduce-dialog :visible.sync="introduceDialogConfig.visible" @close="introduceDialogConfig.visible = false"/>
      <warm-prompt-dialog :visible.sync="warmPromptDialogConfig.visible" :desc="warmPromptDialogConfig.desc" :cancelTxt="warmPromptDialogConfig.cancelTxt" :confirmTxt="warmPromptDialogConfig.confirmTxt" @cancel="handleAppeal" @confirm="getApplyProductInfo"/>
      <payment-result-dialog :visible="paymentResultDialogConfig.visible" :state="paymentResultDialogConfig.state" @close="handlePaymentResultClose"/>
      <confirm-dialog
        :visible="confirmDialogConfig.visible"
        :desc="confirmDialogConfig.desc"
        @cancel="confirmDialogConfig.visible = false"
        @confirm="handleConfirm"
      />
    </div>
  </div>
</template>

<script>
import store from 'store'
import { mapGetters } from 'vuex'
import CommonHeader from '@/render/components/common/header'
import { GradingNoticeDialog, UseActivateCardDialog, ContactServiceDialog, IntroduceDialog, ConfirmDialog, PaymentResultDialog } from '@/render/components/dialog'
import { Banner, GradingHistory, GradingButton, GradingDialog, IconContact, IconQuestion, ConfirmDialog as WarmPromptDialog } from './components'
import { homeAPI, personalAPI } from '@/apis'
import { USER_INFO, UPDATE_USER_INFO, START_NUMBER_MAPPING, USER_TOKEN } from '@/config/const'
import { dateFormat, debounce, getScoreLevel } from '@/render/utils'
import authUtil from '@/render/utils/auth'

let timer = null
export default {
  name: 'Home',
  props: {},
  data() {
    return {
      noticeList: [],
      historyList: [],
      errorMsg: '',
      testQualifications: false,
      applyQualifications: false,
      certificateQualifications: false,
      showButton: false,
      nextTestTime: '',
      gradingInfo: {},
      dialogConfig: {
        visible: false,
        title: ''
      },
      noticDialogConfig: {
        visible: false,
        product: null
      },
      useActivateCardDialogConfig: {
        visible: false,
        product: null
      },
      paymentResultDialogConfig: {
        visible: false,
        state: 6
      },
      contactServiceDialogConfig: {
        visible: false
      },
      introduceDialogConfig: {
        visible: false
      },
      warmPromptDialogConfig: {
        visible: false,
        cancelTxt: '免费重考',
        confirmTxt: '付费申请',
        desc: ''
      },
      confirmDialogConfig: {
        visible: false,
        desc: '',
      },
      orderInfo: null,
      userTestLogUid: '',
      moveMode: 'drag'
    }
  },
  components: {
    CommonHeader,
    Banner,
    GradingHistory,
    GradingButton,
    GradingDialog,
    GradingNoticeDialog,
    UseActivateCardDialog,
    IntroduceDialog,
    IconContact,
    IconQuestion,
    ContactServiceDialog,
    ConfirmDialog,
    WarmPromptDialog,
    PaymentResultDialog
  },
  computed: {
    ...mapGetters('auth', ['token']),
    disabled() {
      return !(this.testQualifications || this.applyQualifications)
    }
  },
  mounted() {
    this.refresh()
    this.polling()
  },
  destroyed() {
    timer && clearInterval(timer)
  },
  methods: {
    polling() {
      timer = setInterval(() => {
        console.log('=====Token=====', this.token)
        console.log('====localToken====', authUtil.getToken())
        if (this.token !== authUtil.getToken()) location.reload()
      }, 3000)
    },
    refresh() {
      this.$store.dispatch('grading/clearGradingData')
      this.checkUserApplyTestPermission()
      this.getTestLogList()
      this.getMessageList()
    },
    handlePaymentResultClose() {
      this.paymentResultDialogConfig.visible = false
      this.refresh()
    },
    handleApplySuccess() {
      this.noticDialogConfig.visible = false
      this.noticDialogConfig.product = null
      this.paymentResultDialogConfig.visible = true
      this.paymentResultDialogConfig.state = 7
    },
    handleUseActivateCodeSuccess() {
      this.useActivateCardDialogConfig.visible = false
      this.useActivateCardDialogConfig.product = null
      this.paymentResultDialogConfig.visible = true
      this.paymentResultDialogConfig.state = 6
    },
    handleUseActivateCode(product) {
      this.noticDialogConfig.visible = false
      this.useActivateCardDialogConfig.visible = true
      this.useActivateCardDialogConfig.product = product
    },
    formatTimes(times) {
      if (times) {
        return `${parseInt(times / 60)}分${times % 60}秒`
      } else {
        return ''
      }
    },
    clickContact() {
      this.contactServiceDialogConfig.visible = true
      this.contactServiceDialogConfig.desc = ''
      this.dialogConfig.visible = false
      this.noticDialogConfig.visible = false
      this.introduceDialogConfig.visible = false
    },
    clickQuestion() {
      this.introduceDialogConfig.visible = true
      this.contactServiceDialogConfig.visible = false
      this.dialogConfig.visible = false
      this.noticDialogConfig.visible = false
    },
    handleClickGrading(testLogUid) {
      this.$router.push({ path: '/grading/replay', query: { testLogUid } })
    },
    async getTestLogList() {
      const result = await homeAPI.getTestLogList({
        completeFlag: 2,
        userUid: store.get(USER_INFO).uid,
        field: 'start_time'
      })
      const weekMapping = {
        0: '日',
        1: '一',
        2: '二',
        3: '三',
        4: '四',
        5: '五',
        6: '六',
      }
      this.historyList = result.data ? result.data.map(item => {
        item.paperLevel = Number(item.paperLevel)
        item.passLevel = item.paperLevel
        item.levelImage = [15, 14, 13, 12, 11].includes(item.paperLevel) ? require(`@/render/assets/images/home/level/${item.paperLevel}.png`) : ''
        item.startDate = dateFormat('YYYY-mm-dd', new Date(item.startTime))
        item.startWeek = '星期' + weekMapping[new Date(item.startTime).getDay()]
        item.scoreLevel = getScoreLevel(item.score, item.passScore)
        item.startNumber = START_NUMBER_MAPPING[item.scoreLevel]
        return item
      }) : []
    },
    async checkUserApplyTestPermission() {
      let { data } = await homeAPI.postCheckUserApplyTestPermission()
      const { applyQualifications, testQualifications, certificateQualifications, showButton, user } = data
      this.applyQualifications = applyQualifications
      this.testQualifications = testQualifications
      this.certificateQualifications = certificateQualifications
      this.showButton = showButton
      if (user.loginNum === 1) {
        this.introduceDialogConfig.visible = true
      }
      store.set(USER_INFO, user)
      this.$bus.emit(UPDATE_USER_INFO, user)
    },
    async getMessageList() {
      let result = await homeAPI.getMessageList({ isDeleted: 'no' })
      this.noticeList = result.data || []
    },
    async handleAppeal() {
      // this.warmPromptDialogConfig.visible = false
      this.confirmDialogConfig = {
        visible: true,
        desc: '是否确认进行申请重考操作，你还有' + (this.warmPromptDialogConfig.spareAppealNum) + '次重考机会！',
      }
    },
    async getApplyProductInfo() {
      let { data } = await homeAPI.postGetApplyProductInfo()
      this.noticDialogConfig.product = data
      this.warmPromptDialogConfig.visible = false
      this.noticDialogConfig.visible = true
    },
    async handleConfirm() {
      await personalAPI.postApplyAppeal({
        uid: this.warmPromptDialogConfig.orderUid,
      })
      this.confirmDialogConfig.visible = false
      Object.assign(this.contactServiceDialogConfig, {
        visible: true,
        desc: '您已成功申请重考，请耐心等待五个工作日内的申诉结果，结果会以短信形式发送到你的手机上。'
      })
      this.checkUserApplyTestPermission()
    },
    async repeatApplyTestPermission() {
      const result = await homeAPI.postRepeatApplyTestPermission()
      const { repeatApplyQualifications, orderUid, spareAppealNum } = result.data
      if (repeatApplyQualifications) {
        this.getApplyProductInfo()
      } else {
        Object.assign(this.warmPromptDialogConfig, {
          // desc: '您当前还有可<span>免费重考</span>机会，建议选择<span>免费重考</span>也可在<span>我的考级</span>右上角中发起重考申请！是否仍然坚持<span>付费申请</span>考级？',
          orderUid,
          spareAppealNum
        })
        this.handleAppeal()
      }
    },
    async getTestPaper() {
      let result = await homeAPI.postGetTestPaper()
      let { testPaper, orderInfo, userTestLogUid } = result.data
      let gradingInfo = this.gradingInfo
      if (testPaper.detailList && testPaper.detailList.length > 0) {
        testPaper.detailList = testPaper.detailList.filter(ele => {
          return ele.count !== 0
        })
        testPaper.detailList.sort((prev, next) => {
          return prev.sortNumber - next.sortNumber
        })
        gradingInfo.passScore = testPaper.passScore
        let count = 0
        let score = 0
        let totalCount = 0
        for (let i = 0; i < testPaper.detailList.length; i++) {
          totalCount += testPaper.detailList[i].count
          gradingInfo.totalCount = totalCount
          switch (testPaper.detailList[i].typeCode) {
            case 'national_iconic':
              gradingInfo['nationalCount'] = testPaper.detailList[i].count || 0
              gradingInfo['nationalScore'] = testPaper.detailList[i].score || 0
              break
            case 'ai':
              gradingInfo['aiCount'] = testPaper.detailList[i].count || 0
              gradingInfo['aiScore'] = testPaper.detailList[i].score || 0
              break
            default:

              gradingInfo['choiceCount'] = count + (testPaper.detailList[i].count || 0)
              gradingInfo['choiceScore'] = score + (testPaper.detailList[i].score || 0)
              break
          }
        }
      }
      this.$store.commit('grading/setTestPaper', testPaper || {})
      gradingInfo.totalTime = testPaper.totalTime
      this.gradingInfo = gradingInfo
      if (!this.disabled) {
        this.dialogConfig.visible = true
        this.dialogConfig.title = `试卷信息（${testPaper.name}）`
      }
      this.orderInfo = orderInfo
      if (orderInfo.productState === 7) this.userTestLogUid = userTestLogUid
    },
    async clickButton () {
      this.disabled && await this.checkUserApplyTestPermission()
      if (this.applyQualifications) {
        this.repeatApplyTestPermission()
      } else {
        this.getTestPaper()
      }
    },
    clickRegistration() {
      this.$router.push('/personal-registration')
    },
    handleUseActivateCardDialogClose() {
      this.useActivateCardDialogConfig.visible = false
      this.useActivateCardDialogConfig.product = null
    },
    handleClose () {
      if (this.applyQualifications) {
        this.noticDialogConfig.visible = false
      } else {
        this.dialogConfig.visible = false
      }
    },
    handleStart: debounce(async function() {
      const userInfo = store.get(USER_INFO)
      if (this.orderInfo && this.orderInfo.productState === 5 || !this.userTestLogUid) {
        const testPaper = this.$store.getters['grading/testPaper']
        const params = {
          userUid: userInfo.uid,
          userName: userInfo.name,
          startTime: dateFormat('YYYY-mm-dd HH:MM:SS', new Date()),
          totalTime: testPaper.totalTime,
          paperUid: testPaper.uid,
          paperName: testPaper.name,
          paperLevelUid: testPaper.levelUid,
          paperLevel: testPaper.level,
          totalScore: testPaper.score,
          passScore: testPaper.passScore
        }
        let testLogResult = await homeAPI.saveTestLog(params)
        this.userTestLogUid = testLogResult.data.uid
        await personalAPI.postOrderSave({
          uid: this.orderInfo.uid,
          productState: 7
        })
      }
      this.$store.commit('grading/setTestLogUid', this.userTestLogUid)
      this.$store.commit('grading/setTotalTime', this.gradingInfo.totalTime)
      this.$store.commit('grading/setMoveMode', this.moveMode)
      this.$router.push('/grading?orderUid=' + this.orderInfo.uid)
    })
  },
}
</script>

<style lang="scss" scoped>
  .home-index-page {
    height: 100vh;
    &__content {
      position: relative;
      flex: 1;
      background: url('../../assets/images/home/bg.png') no-repeat left top;
      background-size: 100% 100%;
    }
    ::v-deep {
      .grading-history {
        padding-bottom: val(98);
      }
      .button-list {
        position: fixed;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
      .dialog {
        &.grading-dialog {
          width: val(750);
        }
        .dialog-content {
          .content-area {
            padding-top: val(40);
            display: flex;
            flex-direction: column;
            // align-items: center;
            padding: val(40) val(93) 0;
            .row {
              display: flex;
              align-items: center;
              p {
                width: 50%;
                font-size: val(32);
                font-weight: 500;
                color: #3E2C00;
                margin-bottom: val(16);
                &:first-of-type {
                  margin-right: val(24);
                }
              }
            }
            .move-mode {
              &-tips {
                margin-bottom: val(16);
                font-size: val(18);
                color: #FF2727;
                line-height: val(30);
              }
              &-chose {
                width: val(200);
                height: val(56);
                padding-left: val(28);
                display: flex;
                align-items: center;
                background: linear-gradient(180deg, #FFFDF9 0%, #FEF5E5 100%);
                box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
                border-radius: 4px 4px 4px 4px;
                .el-radio__label {
                  display: flex;
                  align-items: center;
                  img {
                    margin-right: val(6);
                    width: auto;
                    height: val(32);
                  }
                  span {
                    font-size: val(24);
                    color: #593C24;
                  }
                }
                .el-radio__inner {
                  width: val(16);
                  height: val(16);
                }
                &.is-checked {
                  background: #AB8566;
                  box-shadow: inset 0px 3px 12px 1px rgba(0,0,0,0.45);
                  span {
                    color: #FFEFDB;
                  }
                  .el-radio__input.is-checked .el-radio__inner {
                    border-color: #593C24;
                    background: #fff;
                    &::after {
                      width: val(8);
                      height: val(8);
                      background-color: #593C24;
                    }
                  }
                }
              }
            }
          }
          .dialog-button {
            margin: val(40) auto 0;
            width: val(200);
            height: val(56);
            line-height: val(56);
            text-align: center;
            border-radius: val(6);
            background: #AB8566;
            box-shadow: 0px val(3) val(6) rgba(0, 0, 0, 0.2);
            font-size: val(24);
            font-weight: 400;
            color: #FFEFDB;
            cursor: pointer;
          }
          &.start-grading {
            padding-bottom: val(42);
            .content-area {
              p {
                font-size: val(20);
                font-weight: 400;
              }
            }
            .dialog-button {
              margin-top: val(46);
              margin-bottom: val(20);
            }
            .tips {
              text-align: center;
              font-size: val(16);
              font-weight: 500;
              color: #3E2C00;
              line-height: val(30);
              span {
                color: #FF0000;
              }
            }
          }
        }
      }
    }
  }
</style>
